import React from "react";
import { MdOutlineInfo } from "react-icons/md";
import "./SharedStyles.scss";

interface IProps {
  message: string;
}

const EAPageMessage: React.FC<IProps> = ({ message }) => {
  // Zabezpieczenie przed message, który ma tylko same znaczniki HTML
  if (message && message.length > 12) {
    return (
      <div className="page-message">
        <MdOutlineInfo className="page-message-icon" />
        <article dangerouslySetInnerHTML={{ __html: message }}></article>
      </div>
    );
  }

  return null;
};

export default EAPageMessage;
